//@flow

import React from 'react';

import Table from '../../../../assets/images/pages/pizza/fields/pizza_mise02@3x.png';

type Props = {||};

export default class PizzaTable extends React.PureComponent<Props> {
  render() {
    return <img className="pizza-image pizza-table" src={Table} />;
  }
}
